import { Component, Input } from '@angular/core';
import { ContainerMovementListItem } from '../../../Container/model/ContainerMovementListItem';
import { AbstractContainerJobTypeHelper } from '../../../Container/Helper/AbstractContainerJobTypeHelper';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-container-job-dehire-point-details',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './container-job-dehire-point-details.component.html',
  styleUrl: './container-job-dehire-point-details.component.scss'
})
export class ContainerJobDehirePointDetailsComponent {
  @Input()
  currentLegData?: ContainerMovementListItem;

  @Input()
  firstContainerLeg?: ContainerMovementListItem;

  @Input()
  lastContainerLeg?: ContainerMovementListItem;

  @Input()
  isInboundJob: boolean = false;

  getEmptyDehirePointName(): string {
    if (this.isInboundJob) {
      if (this.lastContainerLeg) {
        return this.lastContainerLeg.toName;
      }
    } else if (!this.isInboundJob) {
      if (this.firstContainerLeg) {
        return this.firstContainerLeg.fromName;
      }
    }
    return '';
  }
}
